import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getallMemberViolations = createAsyncThunk(
  "violation/getallMemberViolations",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getallMemberViolations.url,
        method: API.admin.getallMemberViolations.method,
      });

      return data?.memberViolations;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const resetViolation = createAsyncThunk(
  "violation/resetViolation",
  async (
    param: { memberId: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.resetViolation.url + param.memberId,
        method: API.admin.resetViolation.method,
      });
      toastHelper.success(data?.message);
      param.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getViolationsByMemberId = createAsyncThunk(
  "violation/getViolationsByMemberId",
  async (param: { memberId: number }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getViolationsByMemberId.url + param.memberId,
        method: API.admin.getViolationsByMemberId.method,
      });
      return data?.memberViolations;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteViolation = createAsyncThunk(
  "violation/deleteViolation",
  async (
    param: { violationId: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteViolation.url + param.violationId,
        method: API.admin.deleteViolation.method,
      });

      toastHelper.success(data?.message);
      param.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addMemberViolation = createAsyncThunk(
  "violation/addMemberViolation",
  async (
    params: {
      memberId: number;
      description: string;
      score: number;
      image?: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addMemberViolation.url,
        method: API.admin.addMemberViolation.method,
        data: params,
      });
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateMemberViolation = createAsyncThunk(
  "violation/updateMemberViolation",
  async (
    params: {
      memberViolationId: number;
      description: string;
      score: number;
      image?: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateMemberViolation.url,
        method: API.admin.updateMemberViolation.method,
        data: params,
      });
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
